import React from "react";
import { PAYMENT_METHOD_TYPE } from "utils/constants/payment";

const FPX = () => {
  return (
    <div className="paymentMethod__container bg-white relative">
      <div
        className={`image__cover--after paymentMethod--${PAYMENT_METHOD_TYPE.FPX}`}
      ></div>
      <style jsx>{`
        :global(.paymentMethod--${PAYMENT_METHOD_TYPE.FPX}::after) {
          background-image: url("/assets/paymentMethod--${PAYMENT_METHOD_TYPE.FPX}.png");
        }
      `}</style>
    </div>
  );
};

export default FPX;
